export default __webpack_public_path__ + "static/contactMainBLI-516bd45aa63ed3d379713c729c4ce2bb.svg";